import styled from 'styled-components';
import Col from 'react-bootstrap/Col';

export const ColContainer = styled(Col)`
  background-color: #ededed;
  padding: 5rem 1rem;
  width: 90%;
  max-width: 90%;
  margin: auto;
  
  @media (min-width: 992px) {
    padding: 2rem 2rem;
    width: 80%;
    max-width: 80%;
  }

  @media (max-width: 576px) {
    padding: 1rem 0.5rem;
    width: 95%;
    max-width: 95%;
  }
`;

export const AccHeader = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 576px) {
    font-size: 0.875rem;
  }
`;

// Add CSS class for faq-link
export const Link = styled.a`
  color: #104382;
  text-decoration: underline;

  &:hover {
    color: #0a2b5c;
  }

  &.faq-link {
    color: #104382;
    text-decoration: underline;

    &:hover {
      color: #0a2b5c;
    }
  }
`;